module.exports = __webpack_public_path__ + "static/media/INLAND-FREIGHT.130690c7.jpg";